$('body').on('blur', '.event input[name="amount"]', function() {
    var $this = $(this);
    var amount = parseFloat($this.val());

    if (isNaN(amount) || amount < parseFloat($this.attr('data-min'))) {
        $this.val($this.attr('data-min'));
    }
});

// submitting the event form
$('body').on('submit', '.event form', function () {
    // var fields = $(this).serializeArray();
    var $this = $(this);
    var error = false;

    $('.event .required').each(function () {
        if ($(this).val() === '') {
            error = true;
        }
    });

    if (error) {
        showNotice('Error', 'Please fill out all required fields', 'Close');
        return false;
    }

    if (!$('.event input[name="card_number"]').length) {
        var payload = {};
        payload['_token'] = $('meta[name="csrf-token"]').attr('content');
        payload.name = $('.event input[name="name"]').val();
        payload.company_name = $('.event input[name="company_name"]').val();
        payload.email = $('.event input[name="email"]').val();
        payload.phone = $('.event input[name="phone"]').val();
        payload.message = $('.event textarea[name="message"]').val();
        // console.log(payload);

        loading('Processing...');
        $.ajax({
            type: 'POST',
            url: $this.attr('action'),
            data: payload,
            dataType: 'json',
            success: function (data) {
                unloading();
                // console.log(data);
                if (data.success) {
                    showNotice('Success', data.message, 'close');
                    $('.event form')[0].reset();
                } else {
                    showNotice('event Error', data.message, 'close');
                }
            },
            error: function (request) {
                console.log(request.responseText);
            }
        });

        return false;
    }

    loading('Processing...');
    // create the stripe token
    Stripe.setPublishableKey($('body').attr('data-stripe'));
    Stripe.card.createToken({
        name: $('.event input[name="name"]').val(),
        number: $('.event input[name="card_number"]').val(),
        cvc: $('.event input[name="cvv"]').val(),
        exp_month: $('.event input[name="month"]').val(),
        exp_year: $('.event input[name="year"]').val()
    }, function (status, response) {
        if (response.error) {
            showNotice('Error', response.error.message, 'Close');
            unloading();
            error = true;
            return false;
        }

        var payload = {};
        payload['_token'] = $('meta[name="csrf-token"]').attr('content');
        payload.stripe_token = response.id;
        payload.name = $('.event input[name="name"]').val();
        payload.company_name = $('.event input[name="company_name"]').val();
        payload.email = $('.event input[name="email"]').val();
        payload.phone = $('.event input[name="phone"]').val();
        payload.amount = $('.event input[name="amount"]').val();
        payload.brand = response.card.brand;
        payload.last_four = response.card.last4;
        payload.month = $('.event input[name="month"]').val();
        payload.year = $('.event input[name="year"]').val();
        payload.message = $('.event textarea[name="message"]').val();
        // console.log(payload);

        loading('Processing...');
        $.ajax({
            type: 'POST',
            url: $this.attr('action'),
            data: payload,
            dataType: 'json',
            success: function (data) {
                unloading();
                // console.log(data);
                if (data.success) {
                    showNotice('Success', data.message, 'close');
                    $('.event form')[0].reset();
                } else {
                    showNotice('event Error', data.message, 'close');
                }
            },
            error: function (request) {
                console.log(request.responseText);
            }
        });

        return false;
    });

    return false;
});